import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DropdownService} from "../../services/dropdown.service";
import {IncidentService} from "../../services/incident.service";
import {
  AgencyORIList,
  CountyCityList,
  icJWT_Account,
  IncidentRecord,
  IncidentSearchParams,
  LabInfo
} from "../../NIBINInterface";
import {AuthService} from "../../services/auth.service";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-search-universal-basic',
  templateUrl: './search-universal-basic.component.html',
  styleUrls: ['./search-universal-basic.component.css'],
  providers: [DropdownService, IncidentService]
})
export class SearchUniversalBasicComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};
  searchParams: IncidentSearchParams = <IncidentSearchParams>{
    labs:[]
  };
  labs: LabInfo[] = [];

  AgencyListControl = new FormControl();
  AgencyList: AgencyORIList[] = []
  filteredAgenyList!: Observable<AgencyORIList[]>;
  constructor(private authService: AuthService,private dropdownService: DropdownService,private incidentService: IncidentService) { }

  @Output('Search') search = new EventEmitter<IncidentSearchParams>()
  @Output('Reload') Reload = new EventEmitter<boolean>()

  ngOnInit(): void {
    this.user = this.authService.getUser()
    this.loadLabsList();
    this.resetSearchParams();

    this.filteredAgenyList = this.AgencyListControl.valueChanges.pipe(
      startWith(''),
      map((value:string) => this._filter(value)),
    );

  }

  private _filter(value: string): AgencyORIList[] {
    const filterValue = value.toLowerCase();

    return this.AgencyList.filter(option => {
      if(option.DeptName)
        return option.DeptName.toLowerCase().includes(filterValue);
      return 0;
    });
  }

  //BEGIN: FOR SELECT ALL [LABs]
  isChecked(): boolean {
    return (this.searchParams.labs != null && this.labs.length === this.searchParams.labs.length);
  }

  isIndeterminate(): boolean {
    return (this.searchParams.labs != null && this.labs.length > this.searchParams.labs.length && this.searchParams.labs.length!==0);
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.searchParams.labs = []
      for(let lab of this.labs){
        this.searchParams.labs.push(lab.LAB_SN)
      }
    } else {
      this.searchParams.labs = []
    }
  }
  //END: FOR SELECT ALL [LABs]

  async loadLabsList(): Promise<void>{
    this.AgencyList = await this.dropdownService.getAllAgency();
    this.labs = await this.dropdownService.getLabsList();
  }

  submitSearch():void {

    this.search.emit(this.searchParams)
  }

  resetSearchParams(): void{
    this.searchParams = <IncidentSearchParams>{
      labs:[],
      agency: null,
      casenumber: null,
      labnumber: null,
      fromdate: null,
      todate: null,
      weapon_serial:null,
      person_sbi:null,
      person_fbi:null,
      person_lastname:null,
      person_firstname:null,
      referencenumber:null
    }

    this.searchParams.labs?.push(this.user.CurrentDept)
  }

  reload() {
    this.resetSearchParams()
    this.Reload.emit(true)
  }
}
